function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import c from 'classnames';
import prettyBytes from 'pretty-bytes';
import Icon from '../Icon';
var Download = function Download(_ref) {
  var source = _ref.source,
    title = _ref.title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$filesize = _ref.filesize,
    filesize = _ref$filesize === void 0 ? null : _ref$filesize,
    _ref$filename = _ref.filename,
    filename = _ref$filename === void 0 ? '' : _ref$filename,
    materialIconName = _ref.materialIconName,
    mime = _ref.mime,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    className = _ref.className;
  var classes = c('Download', className);
  var _mime$split = mime.split('/'),
    _mime$split2 = _slicedToArray(_mime$split, 2),
    mimeType = _mime$split2[0],
    mimeSubType = _mime$split2[1];
  var extension = filename.match(/\w+$/);
  return /*#__PURE__*/React.createElement("a", {
    className: classes,
    target: target,
    href: source,
    rel: "noreferrer"
  }, materialIconName ? /*#__PURE__*/React.createElement(Icon, {
    className: "Download__icon Icon-".concat(mimeType, " Icon-").concat(mimeSubType),
    name: materialIconName,
    flair: "outlined"
  }) : /*#__PURE__*/React.createElement("span", {
    className: "Download__icon icon icon-download icon-".concat(mimeType, " icon-").concat(mimeSubType)
  }), /*#__PURE__*/React.createElement("div", {
    className: "Download__content"
  }, /*#__PURE__*/React.createElement("span", {
    className: "Download__title label"
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: "Download__description"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "Download__attributes"
  }, extension && /*#__PURE__*/React.createElement("span", {
    className: "Download__extension"
  }, extension[0], "\xA0"), filesize && /*#__PURE__*/React.createElement("span", {
    className: "Download__filesize"
  }, "(", prettyBytes(filesize), ")")));
};
export default Download;